import React, { useState, useEffect } from "react";
import * as Mui from "@mui/material";
import { themes } from "services/constants";
import { useDispatch } from "react-redux";
import { setGlobalSearchValue } from "services/Redux/userToken";
import { CustomAutoComplete } from "components/CustomComponents/CustomAutoComplete";
import { useFetch } from "services/hooks/useFetch";
import { useSelector } from "react-redux";
import { DownloadForOffline } from "@mui/icons-material";
import { BackArrow } from "components/CustomComponents/BackArrow";
import { customGetAPI } from "services/utils/CustomAPI";
import { showToast } from "services/utils/Status";
import { ESIReportTable } from "./ESIReportTable";
import { Loader } from "components/Loader";

const esiFilterKey = [
  "esi_no",
  "employee_id",
  "user_name",
  "gross_pay",
  "per_day_salary",
  "paid_days",
  "employee_esi",
  "company_esi",
  "total_esi",
];

export const ESIReport = ({ setShowReport, reportName }) => {
  const {
    domain,
    token,
    globalSearchValue,
    topbarCompanyId,
    topbarCompanyName,
  } = useSelector((state) => state.tokenReducer);
  const dispatch = useDispatch();
  const [companyId, setCompanyId] = useState(0);
  const [ESIDetails, setESIDetails] = useState([]);
  const [esiReportState, setEsiReportState] = useState([]);
  const [paySheduleDetails, setPayScheduleDetails] = useState(true);
  const [getEsiReportApi, setGetEsiReportApi] = useState(false);
  const [getPayScheduleDetails, setGetPayScheduleDetails] = useState([]);
  const [payScheduleName, setPayScheduleName] = useState("");
  const [listViewPage, setListViewPage] = useState(0);
  const [loadingPayScheduleDetails, setLoadingPayScheduleDetails] =
    useState(false);
  const {
    result: payShedule,
    loading,
    setLoad: reCallApi,
  } = useFetch(
    companyId !== 0 ? `${domain}payschedule-report/?company=${companyId}` : null
  );

  useEffect(() => {
    if (topbarCompanyId) {
      setCompanyId(topbarCompanyId);
      reCallApi(true);
      setTimeout(function () {
        setPayScheduleDetails(true);
      }, 300);
    }
  }, [reCallApi, topbarCompanyId]);

  useEffect(() => {
    if (payShedule.length !== 0 && paySheduleDetails && !loading) {
      setGetPayScheduleDetails(payShedule[0] ? payShedule[0] : []);
      setPayScheduleName(payShedule[0] ? payShedule[0]?.name : "");
      setPayScheduleDetails(false);
      if (payShedule[0]) {
        setLoadingPayScheduleDetails(true);
        setGetEsiReportApi(true);
      }
    } else if (payShedule.length === 0) {
      setGetPayScheduleDetails([]);
      setPayScheduleName("");
      setESIDetails([]);
    }
  }, [loading, payShedule, paySheduleDetails]);

  useEffect(() => {
    const getESIReports = async () => {
      const res = await customGetAPI(
        `${domain}pay-schedule/detailed/esi-report/?pay_schedule_id=${getPayScheduleDetails?.id}`
      );
      if (res.ok) {
        setESIDetails(res?.responseDetails?.report_data);
        setEsiReportState(res?.responseDetails?.report_data);
        setLoadingPayScheduleDetails(false);
      } else {
        setESIDetails([]);
        setLoadingPayScheduleDetails(false);
      }
    };
    if (getEsiReportApi) {
      setGetEsiReportApi(false);
      getESIReports();
    }
  }, [domain, getEsiReportApi, getPayScheduleDetails?.id, token]);

  const handlePaySchedule = (event, data) => {
    if (data) {
      setGetPayScheduleDetails(data);
      setPayScheduleName(data.name);
      setGetEsiReportApi(true);
      setLoadingPayScheduleDetails(true);
    }
  };

  const exportEPFReportDetails = () => {
    if (ESIDetails.length !== 0) {
      let dataPreparation = [];
      ESIDetails?.forEach((element) => {
        let overAllData = {
          user_name: element.user_name,
          employee_id: element.employee_id,
          esi_no: element.esi_no,
          gross_salary: element.gross_pay,
          perdaysalary: element.per_day_salary,
          numberofdays_in_esi: element.paid_days,
          employee_contribution: element.employee_esi,
          company_contribution: element.company_esi,
          totalesiamount: element.total_esi,
        };
        dataPreparation = [...dataPreparation, overAllData];
      });
      const company_Name = ["Company Name"];
      const pay_ScheduleName = ["PaySchedule Name"];
      const paySchedulePeriod = ["PaySchedule Period"];
      const TableHead = ["Employee Name"];
      TableHead.push("Employee Id");
      TableHead.push("ESI No");
      TableHead.push("Gross Pay");
      TableHead.push("Per day salary");
      TableHead.push("Number of days in esi");
      TableHead.push("Employee contributions");
      TableHead.push("Company contributions");
      TableHead.push("Total ESI amount");
      company_Name.push(topbarCompanyName);
      pay_ScheduleName.push(payScheduleName);
      paySchedulePeriod.push(
        getPayScheduleDetails.start_date +
          "  to  " +
          getPayScheduleDetails.end_date
      );
      const items = dataPreparation;
      const replacer = (key, value) => (value === null ? "" : value);
      const header = Object.keys(items[0]).filter(
        (field) => field !== "break_details"
      );
      let csv = items.map((row) =>
        header
          .map((fieldName) => JSON.stringify(row[fieldName], replacer))
          .join(",")
      );
      csv.unshift(TableHead.join(","));
      csv.unshift(paySchedulePeriod.join(","));
      csv.unshift(pay_ScheduleName.join(","));
      csv.unshift(company_Name.join(","));
      csv = csv.join("\r\n");
      const ConvertData = csv;
      const element = document.createElement("a");
      const file = new Blob([ConvertData], {
        type: "text/plain",
      });
      element.href = URL.createObjectURL(file);
      element.download = `${payScheduleName}.csv`;
      document.body.appendChild(element);
      element.click();
    } else {
      showToast("error", "No data available");
    }
  };

  useEffect(() => {
    const filteredResults = esiReportState?.filter((item) =>
      esiFilterKey?.some((key) =>
        item[key]
          ?.toString()
          .toLowerCase()
          .includes(globalSearchValue?.toString().toLowerCase())
      )
    );
    setESIDetails(filteredResults);
    setListViewPage(globalSearchValue ? 0 : listViewPage);
  }, [globalSearchValue, esiReportState, listViewPage]);

  return (
    <React.Fragment>
      <Mui.Grid container sx={{ paddingTop: 2, paddingBottom: 1 }}>
        <Mui.Grid xs={0.5} sx={{ paddingTop: 2 }}>
          <BackArrow
            actionFunction={() => {
              setShowReport(false);
              dispatch(setGlobalSearchValue(""));
            }}
          />
        </Mui.Grid>
        <Mui.Grid xs={2.5}></Mui.Grid>
        <Mui.Grid xs={5.9}></Mui.Grid>
        <Mui.Grid xs={2.5}>
          <Mui.Typography>Pay Schedule</Mui.Typography>
          <CustomAutoComplete
            dataList={payShedule.map((obj) => ({
              ...obj,
              label: obj.name,
            }))}
            selectedValue={payScheduleName}
            updateDataFunction={handlePaySchedule}
            placeHolder="Please select the Payshedule"
          />
        </Mui.Grid>
        <Mui.Grid xs={0.5} sx={{ paddingTop: 1 }}>
          <Mui.IconButton onClick={() => exportEPFReportDetails()}>
            <DownloadForOffline
              size="large"
              sx={{ color: themes.downloadIconColor, fontSize: 50 }}
            />
          </Mui.IconButton>
        </Mui.Grid>
      </Mui.Grid>
      {loadingPayScheduleDetails ? (
        <Loader info="Loading..." />
      ) : (
        <>
          {ESIDetails?.length === 0 ? null : (
            <Mui.Grid container xs={12}>
              <Mui.Grid xs={8.9}></Mui.Grid>
              <Mui.Grid xs={3.1} sx={{ paddingLeft: 0.5 }}>
                <Mui.Typography
                  sx={{
                    fontSize: 16,
                    fontWeight: "bold",
                  }}
                >
                  ESI Report
                </Mui.Typography>
                <Mui.Typography
                  sx={{
                    fontSize: 16,
                    fontWeight: "bold",
                  }}
                >
                  Period {getPayScheduleDetails.start_date} to{" "}
                  {getPayScheduleDetails.end_date}
                </Mui.Typography>
              </Mui.Grid>
            </Mui.Grid>
          )}

          <ESIReportTable
            ESIDetails={ESIDetails}
            listViewPage={listViewPage}
            setListViewPage={setListViewPage}
            esiReportState={esiReportState}
          />
        </>
      )}
    </React.Fragment>
  );
};
